import { render, staticRenderFns } from "./questionBankList.vue?vue&type=template&id=507b9a26&scoped=true&"
import script from "./questionBankList.vue?vue&type=script&lang=js&"
export * from "./questionBankList.vue?vue&type=script&lang=js&"
import style0 from "./questionBankList.vue?vue&type=style&index=0&id=507b9a26&lang=scss&scoped=true&"
import style1 from "./questionBankList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b9a26",
  null
  
)

export default component.exports